import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import amplitude from 'amplitude-js'
import LoadIcon from '../../components/LoadIcon'
import ChatSection from '../../components/ChatSection.js'
import { muteMusic, unmuteMusic } from '../../ducks/layout'
import screen from '../../images/mobile/screen.png'
import { ChatMemberLoungeDb, AccessDb } from '../../firebaseConfig'
import openTheatre from '../../images/mobile/open-theatre.png'
import closeTheatre from '../../images/mobile/close-theatre.png'
import config from '../../config'
import routes from '../../routes'
import PasscodeModal from '../../components/GlobalModals/PasscodeModal'
import agenda from '../../images/mobile/agenda.png'
import agendaImage from '../../images/event/Agenda6.jpg'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useObject } from 'react-firebase-hooks/database'
import { startTrack, endTrack } from '../../utils/timerHelper'
import { usePageActiveUserCount } from '../../utils/activeUserCount'

const MobileMemberLounge = ({ currentUser, liveUrl, hallNumber }) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const [theatre, setTheatre] = useState(false)
  const [authenticated, setAuthenticated] = useState(hallNumber===1 ? true : false )
  const [showModal, setShowModal] = useState(false)
  const [agendaModal, setAgendaModal] = useState(false)
  const [snapshot, loading, error] = useObject(AccessDb)
  const history = useHistory()
  const initialPath = history.location.pathname.substr(1)

  usePageActiveUserCount(currentUser)

  // useEffect(() => {
  //   if (currentUser.id){
  //     startTrack(currentUser)
  //   }
    
  //   return () => {
  //     if (currentUser.id){
  //       endTrack(currentUser, initialPath)
  //     }
  //   }
  // }, [currentUser.id])
  
  useEffect(() => {
    if (!loading) {
      if (!authenticated) {
        setShowModal(true)
      } else {
        if (!snapshot.val()) {
          toast('Welcome! Live event will only be available on 20 March, 2021 (Sat) 2PM.', {
            toastId: 'eventToast',
          })
          history.push(routes.lobby)
        } else {
          amplitude.getInstance().logEvent(`Visit Member Lounge`)
        }
      }
    }
  }, [loading, snapshot, currentUser.id, authenticated])

  useEffect(() => {
    dispatch(muteMusic())

    return () => {
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    }
  }, [dispatch])

  const hideModal = () => {
    setShowModal(false)
  }

  const toggleAgendaModal = () => {
    if (agendaModal === false)
      amplitude.getInstance().logEvent('Click Agenda')
    setAgendaModal(!agendaModal)
  }

  const videoContainerTheatreStyle = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'black',
    zIndex: '99',
  }

  if (loading || error) {
    return <LoadIcon />
  }
  if (!authenticated) {
    return <PasscodeModal hideModal={hideModal} showModal={showModal} setAuthenticated={setAuthenticated} />
  }
  return (
    <Page>
      {agendaModal && (
        <div className="modal-container">
          <p className="modal-container-close" onClick={toggleAgendaModal}>
            Close
          </p>
          <div className="modal-container-content">
            <img alt="agenda" src={agendaImage} className="content-image" />
          </div>
        </div>
      )}
      <div className="outer-wrapper">
        <div className="container">
          <div className="screen-container">
            <img alt="screen" src={screen} className="screen" />
            <div
              className="video-container"
              style={theatre ? videoContainerTheatreStyle : {}}
            >
              {isLoading && <LoadIcon />}
              <iframe
                title="Live Broadcast"
                src={liveUrl}
                allow="autoplay; fullscreen"
                allowFullScreen
                frameBorder="0"
                onLoad={() => {
                  setIsLoading(false)
                }}
              />
            </div>
          </div>

          <button
            type="button"
            className="theatre-button"
            onClick={() => setTheatre(true)}
          >
            <img alt="icon" src={openTheatre} className="theatre-button-icon" />
            <p className="theatre-button-label">Theatre mode</p>
          </button>
          <div className="buttons-container">
            <img
              alt="agenda-button"
              src={agenda}
              className="agenda"
              onClick={toggleAgendaModal}
            />
          </div>
        </div>

        <div className="chat-container">
          <ChatSection
            currentUser={currentUser}
            firebaseDb={ChatMemberLoungeDb}
            hallName="MemberLounge"
          />
        </div>

        {theatre && (
          <div className="theatre-close">
            <img
              alt="close-icon"
              src={closeTheatre}
              onClick={() => setTheatre(false)}
              className="theatre-close-icon"
            />
          </div>
        )}
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: url(${config.assets.postRegister.portrait});
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  border-radius: 0px 0px 25px 25px;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 95%;
    margin: auto;
    margin-top: 32px;
  }

  .checkin-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 30px 0px 20px 0px;
  }

  .checkin {
    width: 38%;
    height: auto;
  }

  .logo {
    width: 50%;
    height: auto;
  }

  .screen-container {
    width: 100%;
    height: 0;
    padding-bottom: 58.5%;
    position: relative;
  }

  .screen {
    width: 100%;
    position: absolute;
  }

  .video-container {
    width: 92%;
    height: 81%;
    background: #1e1e1e;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50.5%, -51%);

    iframe {
      height: 100%;
      width: 100%;
    }
  }

  .buttons-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0px;
  }

  .agenda {
    width: 45%;
    height: auto;
  }

  .speakers {
    width: 45%;
    height: auto;
  }

  .chat-container {
    width: 100%;
    height: 500px;
    margin-top: 36px;
  }

  .modal-container {
    width: 95%;
    height: 60%;
    border-radius: 30px;
    border: solid 2px #652781;
    position: fixed;
    bottom: 1%;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    z-index: 99;
  }

  .modal-container-close {
    font-size: 12px;
    color: #312384;
    font-weight: bold;
    margin-bottom: 0;
    position: absolute;
    top: 20px;
    right: 30px;
  }

  .modal-container-content {
    width: calc(100% - 60px);
    height: calc(100% - 70px);
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    overflow-y: scroll;
  }

  .content-image {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .theatre-button {
    width: 140px;
    height: 30px;
    background: black;
    margin: 10px 10px 20px 0px;
    float: right;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    opacity: 0.6;
    padding: 0;
  }

  .theatre-button-label {
    color: white;
    font-size: 12px;
    margin: 0px 10px 0px 0px;
  }

  .theatre-button-icon {
    width: 20px;
    margin: 0px 10px;
  }

  .theatre-close {
    color: white;
    background: black;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 99;
    opacity: 0.6;
  }

  .theatre-close-icon {
    width: 20px;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }

    .modal-container {
      max-width: calc(0.95 * 540px);
    }
  }
`

export default MobileMemberLounge
